/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Set_PasswordInputs */



/**
* | output |
* | --- |
* | "Couldn't set your password." |
*
* @param {Auth_Error_Set_PasswordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_error_set_password = /** @type {((inputs?: Auth_Error_Set_PasswordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Set_PasswordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de définir votre mot de passe.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo establecer su contraseña.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível definir sua senha.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile impostare la tua password.")
	return /** @type {LocalizedString} */ ("Couldn't set your password.")
});